import { TextLinkButton } from 'braid-design-system';

// The following code is copied from
// https://github.com/SEEK-Jobs/metropolis/blob/6532f28c32a1063ed3e480b7c51673afec3c2c99/packages/profile-base-ui/src/components/ProfileCardDescription/utils.tsx

const internalUrls = [
  'seek.com',
  'seek.co',
  'jobsdb.com',
  'jobstreet.com',
] as const;

const urlRegex =
  /((?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z()]{1,6}\b(?:[-a-zA-Z0-9()@:%_\+~#?&//=]*))/g;

export const isInternalUrl = (url: string) => {
  const tokenisedUrl = url.split(urlRegex);
  return internalUrls.some(
    (internalUrl) => tokenisedUrl.indexOf(internalUrl) >= 0,
  );
};

export const sanitiseUrl = (url: string) => {
  const matches = url.match(/^https?:\/\//g);
  if (matches === null) {
    return `https://${url}`;
  }
  if (matches[0] === 'http://') {
    return url.replace('http', 'https');
  }
  return url;
};

export const replaceTextWithLinks = (
  text: string,
  onClickFn: (url: string) => void,
): Array<string | JSX.Element> => {
  const splitText = text.split(urlRegex);

  const replacedText = splitText.map((subString, index) => {
    if (index % 2 !== 0) {
      const url = sanitiseUrl(subString);

      return (
        <TextLinkButton
          onClick={() => onClickFn(url)}
          weight="weak"
          key={index}
        >
          {subString}
        </TextLinkButton>
      );
    }

    return subString;
  });

  return replacedText;
};
